"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("../listeners/focusStylesListener");

var _setupStyledComponents = require("../listeners/setupStyledComponents");

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Functions = require("../core/Functions");

var _UnsafeUrl = require("../utils/UnsafeUrl");

var _Links = require("../utils/Links");

var _TabIndex = require("../utils/TabIndex");

var _decorators = require("../utils/propTypes/decorators");

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _ShareButton = _interopRequireDefault(require("../decorators/ShareButton"));

var _validHref = _interopRequireDefault(require("../utils/propTypes/validHref"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var TShirtSize = _interopRequireWildcard(require("../utils/propTypes/tshirtSize"));

var _UITruncateString = _interopRequireDefault(require("../text/UITruncateString"));

var _UIClickable = _interopRequireDefault(require("./UIClickable"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _ButtonConstants = require("../button/ButtonConstants");

var _ActiveProvider = _interopRequireDefault(require("../providers/ActiveProvider"));

// These should be removed once we have 100% adoption of UIApplication
(0, _setupStyledComponents.setupStyledComponents)();

var getClassName = function getClassName(active, block, className, disabled, hovered, responsive, computedSize, computedUse) {
  var _classNames;

  var unstyled = computedUse === 'unstyled';
  return (0, _classnames.default)('uiButton', _ButtonConstants.USE_CLASSES[computedUse], className, (_classNames = {
    'private-button': !unstyled
  }, (0, _defineProperty2.default)(_classNames, _ButtonConstants.SIZE_CLASSES[computedSize] || _ButtonConstants.SIZE_CLASSES.default, !unstyled), (0, _defineProperty2.default)(_classNames, 'private-button--active', active && !unstyled), (0, _defineProperty2.default)(_classNames, 'private-button--block', block && !unstyled), (0, _defineProperty2.default)(_classNames, 'disabled private-button--disabled', disabled && !unstyled), (0, _defineProperty2.default)(_classNames, 'private-button--non-responsive', !responsive), (0, _defineProperty2.default)(_classNames, 'private-button--non-link', _ButtonConstants.LINK_USES.indexOf(computedUse) === -1), (0, _defineProperty2.default)(_classNames, 'private-button--hover', hovered), _classNames));
};

var getUse = function getUse(use) {
  return use && _ButtonConstants.USE_CLASSES[use] ? use : 'secondary';
};

var renderContents = function renderContents(children) {
  var stringBuffer = '';
  var nextChildIndex = 0;

  var childArr = _react.Children.toArray(children);

  return _react.Children.map(children, function (child) {
    nextChildIndex += 1;

    if (child == null) {
      return null;
    } // in response to a breaking change in React 0.15
    // (https://facebook.github.io/react/blog/2016/04/07/react-v15.html#no-more-extra-ltspangts)
    // this wraps any bare strings within a <span> to provide a more
    // predictable DOM for applying automatic spacing rules.


    if (typeof child === 'string') {
      stringBuffer += child;

      if (childArr.length < nextChildIndex || typeof childArr[nextChildIndex] !== 'string') {
        var wrappedStringBuffer = _react.default.createElement("span", null, stringBuffer);

        stringBuffer = '';
        return wrappedStringBuffer;
      } else {
        return null;
      }
    }

    return child;
  });
};

var renderExternalButtonIcon = function renderExternalButtonIcon(external, iconProps) {
  if (!external) return null; // Opening links in a new window is an accessibility anti-pattern.
  // To mitigate this, we add accessible text in the icon to warn that
  // the link will be opened in a new window
  // @link http://diveintoaccessibility.info/day_16_not_opening_new_windows.html

  return _react.default.createElement(_UIIcon.default, (0, _extends2.default)({}, iconProps, {
    "aria-label": _I18n.default.text('salesUI.UILink.externalTitle'),
    className: iconProps.className || 'private-link--external__icon',
    name: "externalLink"
  }));
};

var renderTruncatedContents = function renderTruncatedContents(truncate, truncateStringProps, truncateTooltip, renderedContents, renderedExternalButtonIcon) {
  return truncate ? _react.default.createElement(_UITruncateString.default, (0, _extends2.default)({
    innerClassName: "private-button__truncate-string",
    useFlex: true,
    fixedChildren: renderedExternalButtonIcon,
    tooltip: truncateTooltip || renderedContents
  }, truncateStringProps), _react.default.createElement("span", null, renderedContents)) : renderedContents;
};

var validateProps = function validateProps(external, size, use, computedTarget) {
  (0, _Links.warnIfShouldBeExternal)(external, computedTarget, 'UIButton');
};

var UIButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIButton, _PureComponent);

  function UIButton() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleMouseDown = function (evt) {
      var onMouseDown = _this.props.onMouseDown;

      if (_this.props.disabled) {
        evt.stopPropagation();
      }

      (0, _Functions.callIfPossible)(onMouseDown, evt);
    };

    _this.handleLinkKeyDown = function (evt) {
      // Simulate click on Spacebar, to emulate button behavior
      var key = evt.key;
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onKeyDown = _this$props.onKeyDown,
          onClick = _this$props.onClick;
      (0, _Functions.callIfPossible)(onKeyDown, evt);

      if (typeof onClick !== 'function') {
        return;
      }

      if (key === ' ') {
        if (disabled) {
          evt.preventDefault();
          evt.stopPropagation();
          return;
        }

        onClick(evt); // Prevent scrolling

        evt.preventDefault();
      }
    };

    _this.handleClick = function (evt) {
      var onClick = _this.props.onClick;

      if (_this.props.disabled) {
        evt.preventDefault();
        evt.stopPropagation();
      } else {
        (0, _Functions.callIfPossible)(onClick, evt);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(UIButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          autoFocus = _this$props2.autoFocus,
          buttonRef = _this$props2.buttonRef,
          href = _this$props2.href;

      if (autoFocus && href) {
        if (buttonRef.current) buttonRef.current.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          _useNativeButton = _this$props3._useNativeButton,
          active = _this$props3.active,
          ariaPressed = _this$props3['aria-pressed'],
          block = _this$props3.block,
          buttonRef = _this$props3.buttonRef,
          children = _this$props3.children,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          external = _this$props3.external,
          hovered = _this$props3.hovered,
          href = _this$props3.href,
          iconProps = _this$props3.iconProps,
          __onClick = _this$props3.onClick,
          __onMouseDown = _this$props3.onMouseDown,
          rel = _this$props3.rel,
          responsive = _this$props3.responsive,
          size = _this$props3.size,
          tabIndex = _this$props3.tabIndex,
          target = _this$props3.target,
          truncate = _this$props3.truncate,
          truncateStringProps = _this$props3.truncateStringProps,
          truncateTooltip = _this$props3.truncateTooltip,
          use = _this$props3.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["_useNativeButton", "active", "aria-pressed", "block", "buttonRef", "children", "className", "disabled", "external", "hovered", "href", "iconProps", "onClick", "onMouseDown", "rel", "responsive", "size", "tabIndex", "target", "truncate", "truncateStringProps", "truncateTooltip", "use"]);
      var computedSize = TShirtSize.fromProp(size).long;
      var computedTabIndex = (0, _TabIndex.getTabIndex)(disabled, tabIndex);
      var computedTarget = (0, _Links.getTarget)(external, target);
      var computedUse = getUse(use);
      validateProps(external, size, use, computedTarget);
      var renderedContents = renderContents(children);
      var renderedExternalButtonIcon = renderExternalButtonIcon(external, iconProps);
      var wrappedContents = renderTruncatedContents(truncate, truncateStringProps, truncateTooltip, renderedContents, renderedExternalButtonIcon);
      var computedClassName = getClassName(active, block, className, disabled, hovered, responsive, computedSize, computedUse);
      var commonProps = {
        'aria-disabled': disabled,
        className: computedClassName,
        'data-button-use': computedUse,
        onClick: this.handleClick,
        onMouseDown: this.handleMouseDown,
        ref: buttonRef,
        tabIndex: computedTabIndex
      };

      if (href) {
        var computedRel = (0, _Links.getRel)(rel, computedTarget);
        return (0, _Links.renderSecurityTaggedLink)(href, _react.default.createElement("a", (0, _extends2.default)({}, rest, commonProps, {
          onKeyDown: this.handleLinkKeyDown,
          href: (0, _UnsafeUrl.getSafeUrl)(href),
          rel: computedRel,
          target: computedTarget
        }), wrappedContents, truncate ? null : renderedExternalButtonIcon));
      }

      var ButtonComponent = _useNativeButton ? 'button' : _UIClickable.default;

      if (!_useNativeButton) {
        // Pass buttonRef down directly to the UIClickable
        commonProps.buttonRef = buttonRef;
        delete commonProps.ref;
      }

      return _react.default.createElement(ButtonComponent, (0, _extends2.default)({}, rest, commonProps, {
        "aria-pressed": ariaPressed != null ? ariaPressed : active || undefined,
        disabled: _useNativeButton ? undefined : disabled
      }), wrappedContents);
    }
  }]);
  return UIButton;
}(_react.PureComponent);

UIButton.displayName = 'UIButton';

var UIButtonWithProviders =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UIButtonWithProviders, _React$Component);

  function UIButtonWithProviders() {
    (0, _classCallCheck2.default)(this, UIButtonWithProviders);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(UIButtonWithProviders).apply(this, arguments));
  }

  (0, _createClass2.default)(UIButtonWithProviders, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement(_ActiveProvider.default, this.props, function (activeProviderProps) {
        return _react.default.createElement(_HoverProvider.default, _this2.props, function (hoverProviderProps) {
          return _react.default.createElement(UIButton, (0, _extends2.default)({}, _this2.props, activeProviderProps, hoverProviderProps));
        });
      });
    }
  }]);
  return UIButtonWithProviders;
}(_react.default.Component);

UIButtonWithProviders.propTypes = {
  _useNativeButton: _propTypes.default.bool,
  active: (0, _decorators.hidden)(_propTypes.default.bool),
  autoFocus: _propTypes.default.bool,
  'aria-pressed': _propTypes.default.bool,
  block: _propTypes.default.bool,
  buttonRef: _refObject.default,
  children: _propTypes.default.node,
  disabled: _propTypes.default.bool.isRequired,
  external: _propTypes.default.bool.isRequired,
  hovered: (0, _decorators.hidden)(_propTypes.default.bool),
  href: _validHref.default,
  iconProps: _propTypes.default.object.isRequired,
  responsive: _propTypes.default.bool.isRequired,
  rel: _propTypes.default.string,
  size: TShirtSize.propTypeForSizes(['xs', 'sm', 'md'], ['default']),
  target: _propTypes.default.string,
  truncate: _propTypes.default.bool.isRequired,
  truncateStringProps: _propTypes.default.object.isRequired,
  truncateTooltip: _propTypes.default.node,
  type: _propTypes.default.oneOf(['button', 'reset', 'submit']).isRequired,
  use: _propTypes.default.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired
};
UIButtonWithProviders.defaultProps = {
  _useNativeButton: true,
  disabled: false,
  external: false,
  iconProps: {},
  responsive: true,
  size: 'medium',
  truncate: false,
  truncateStringProps: {},
  type: 'button',
  use: 'secondary'
}; // Expose the core component for tests

UIButtonWithProviders.WrappedComponent = UIButton;
UIButtonWithProviders.CoreComponent = UIButton;
UIButtonWithProviders.displayName = 'UIButtonWithProviders';

var _default = (0, _ShareButton.default)(UIButtonWithProviders);

exports.default = _default;
module.exports = exports.default;